import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"
import { sanitize } from '§/src/utils/functions';

/**
 * Internal dependencies.
 */
import "./_breadcrumb.scss"

const Breadcrumb = props => {
  // set atom class
  const atomClassName = "breadcrumb"
  var atomClass =
    props.className !== undefined
      ? atomClassName + " " + props.className
      : atomClassName;

	const levels = props.levels || 1;

  return (
    <nav className={atomClass} aria-label="breadcrumb">
      <ol className="breadcrumb">
        {props?.wpseo &&
          props.wpseo.map((crumb, index) => {
            const crumbLink = index === 0 ? "/" : crumb.url

            // Current page
            if (props.wpseo.length - 1 === index) {
              return (
                <li
                  key={index}
                  className="breadcrumb-item active"
                  dangerouslySetInnerHTML={{ __html: sanitize(crumb.text) }}
                />
              )

						}	if(index === 0 && props.base){

							return(
								<React.Fragment  key={index++}>
									<li key={index++} className="breadcrumb-item">
										<span dangerouslySetInnerHTML={{ __html: sanitize(crumb?.text) }} />
									</li>
									<li key={index++} className="breadcrumb-item custom-base">
										{props.base}
									</li>
								</React.Fragment>
							)

            // do not add link after # levels
            } else if (index >= levels) {

							return (
								<li
									key={index}
									className="breadcrumb-item"
									dangerouslySetInnerHTML={{ __html: sanitize(crumb.text) }}
								/>
							)

              // normal
            } else {
              return (
                <li key={index} className="breadcrumb-item">
                  <UniversalLink to={crumbLink}>{crumb.text}</UniversalLink>
                </li>
              )
            }
          })}
      </ol>
    </nav>
  )
}

export default Breadcrumb
